import { getUserId } from "metabase/current-user";
import { useSelector } from "metabase/redux";
import { Flex, Icon, Text } from "metabase/ui";
import type Question from "metabase-lib/v1/Question";
import type { Dashboard, ModerationReview } from "metabase-types/api";

import { getVerifiedByText, getVerifiedReview } from "../../utils";

type ModerationReviewTextProps = {
  reviews: ModerationReview[] | undefined;
};

/** "Verified by Ana Ruiz 3 days ago" in an info sidebar; nothing if unverified. */
function ModerationReviewText({ reviews }: ModerationReviewTextProps) {
  const currentUserId = useSelector(getUserId);
  const review = getVerifiedReview(reviews);

  if (!review) {
    return null;
  }

  return (
    <Flex align="center" gap="sm" data-testid="moderation-review-text">
      <Icon name="verified_filled" c="core-brand" />
      <Text>{getVerifiedByText(review, currentUserId)}</Text>
    </Flex>
  );
}

export function ModerationReviewTextForQuestion({
  question,
}: {
  question: Question;
}) {
  return <ModerationReviewText reviews={question.card().moderation_reviews} />;
}

export function ModerationReviewTextForDashboard({
  dashboard,
}: {
  dashboard: Dashboard;
}) {
  return <ModerationReviewText reviews={dashboard.moderation_reviews} />;
}
